<div class="search-container">
  <mds-search-bar class="search-bar"
    [hideEnterButton]="true"
    theme="light"
    placeholder="Search"
  (textChange)="onSearch($event)"> </mds-search-bar>
</div>
@for (item of filteredListData; track trackByIndex(i); let i = $index) {
  <div class="item">
    @if (i === loaderIndex && loader) {
      <mds-loader  class="overlay-loader"></mds-loader>
    }
    <mds-checkbox
      [label]="item.app_name"
      [(ngModel)]="item.checked"
      (valueChange)="onClickCheckbox(item, i)"
    >  {{ item.app_name }}</mds-checkbox>
  </div>
}
